export const updateByProp = <T extends Record<string, any>>(array: T[], updatedValue: T, prop: keyof T) =>
  array.map(item => (item[prop] === updatedValue[prop] ? updatedValue : item));
